import HomeSeo from "../components/seo/home-seo";
import "./home.css";
export default function Home() {
	return (
		<div className="home-container">
			<HomeSeo description="Heron Lane Farm raises pasture-raised lambs in Whatcom County, WA. We sell directly to local families, 4H and FFA members, and through our butcher partners by the quarter, half, or whole." />
			<div className="hero-panel">
				<div className="hero-text">
					<p className="hero-subtitle">
						Heron Lane Farm is a small, family-run farm where our animals are
						more than just livestock—they’re part of the rhythm of our everyday
						life. We raise a small flock of Suffolk sheep with care and
						intention. If you’re looking for farm-raised lamb that’s responsibly
						and kindly raised, we’d be happy to share a bit of our farm with
						you.
					</p>
				</div>
				<img
					src="/images/heronlogoblack1.png"
					alt="Heron Logo"
					className="hero-logo"
				/>
			</div>
			<div className="mission-statement-section">
				<img src="/images/lamb1.avif" alt="Lamb" className="lambs-image" />
				<div className="mission-statement-text">
					From farm to table with care and quality
				</div>
				<a href="/products">
					<button className="cta-button see-our-products-cta">
						See Our Products
					</button>
				</a>
			</div>
			<div className="contact-section">
				<div className="contact-us-card">
					<div className="contact-us-text">
						We sell fully processed, cut and wrapped, locally grown lamb. We
						sell out quickly, so reach out soon to make a reservation. Our lamb
						is raised with care right here on our small farm, and we’re proud to
						offer high-quality meat to our community.
					</div>
					<a href="/contact">
						<button className="cta-button contact-us-cta">Contact Us</button>
					</a>
				</div>
				<img
					src="/images/lamb.avif"
					alt="Lamb"
					className="contact-lamb-image"
				/>
			</div>
			<div className="meet-the-farmers-section">
				<div className="meet-the-farmers-card">
					<div className="meet-the-farmers-text">Meet the Farmers</div>
					<img
						src="/images/heron-lane-farmers.avif"
						alt="Farmers"
						className="farmers-image"
					/>
				</div>
				<div className="farmers-description">
					We have been sheep farming on our small acreage for more than twenty
					years. Over the years, each of our five children raised sheep for 4-H
					or FFA, and we always set one aside to provide for our family. Now
					that the kids are grown and grandkids are beginning to show interest,
					we still enjoy caring for our flock. Our farm, nestled between two
					creeks, boasts lush pastures that are perfect for raising sheep. We
					love watching the flock through the seasons. Spring lambing is always
					exciting, watching the lambs grow is rewarding, and once the pastures
					are lush, it’s a joy to see them grazing contentedly in the green
					fields. We’re proud to offer lamb raised with the same care and
					dedication that has nourished our own family for years.
				</div>
				<a href="/faq">
					<button className="cta-button meet-the-farmers-cta">
						Learn More About Our Farm
					</button>
				</a>
			</div>
		</div>
	);
}
